export default __webpack_public_path__ + "static/media/jackryan3.f874f725.jpg";